import { render, staticRenderFns } from "./PeriodDuration.vue?vue&type=template&id=45e51983&scoped=true&"
import script from "./PeriodDuration.vue?vue&type=script&lang=js&"
export * from "./PeriodDuration.vue?vue&type=script&lang=js&"
import style0 from "./PeriodDuration.vue?vue&type=style&index=0&id=45e51983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e51983",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e51983')) {
      api.createRecord('45e51983', component.options)
    } else {
      api.reload('45e51983', component.options)
    }
    module.hot.accept("./PeriodDuration.vue?vue&type=template&id=45e51983&scoped=true&", function () {
      api.rerender('45e51983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Weekly/components/PeriodDuration.vue"
export default component.exports